import { Children, MouseEvent } from "react";
import { Badge, Box, IconButton, Typography, useTheme } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { Color, StarIcon } from "@bonliva-crm/ui";

type Props = {
  title: string;
  children?: React.ReactNode;
  isDirty?: boolean;
  isClearable?: boolean;
  onClear?: (e: MouseEvent) => void;
  onTitleClick?: (e: React.SyntheticEvent) => void;
  action?: React.ReactNode;
  favorite?: boolean;
  onSetFavorite?: (value: boolean) => void;
};

export function NonCollapsibleFavFilter(props: Props) {
  const theme = useTheme();

  return (
    <Box>
      <Box display="flex" alignItems="center" minHeight="60px">
        <IconButton onClick={() => props.onSetFavorite(!props.favorite)}>
          <StarIcon
            style={{
              fill: props.favorite ? theme.palette.primary.main : theme.palette.info.light
            }}
          />
        </IconButton>

        <Box flex="1" onClick={props.onTitleClick}>
          <Badge
            color="primary"
            variant="dot"
            invisible={!props.isDirty}
            classes={{
              badge: "fav-filter-badge"
            }}
          >
            <Typography
              variant="body1"
              style={{
                color: Color.DetailsInput,
                fontWeight: 500,
                flex: 1,
                cursor: "pointer"
              }}
            >
              {props.title}
            </Typography>
          </Badge>
        </Box>

        {props.isClearable && (
          <IconButton onClick={props.onClear}>
            <Clear fontSize="small" />
          </IconButton>
        )}

        {props.action}
      </Box>

      {props.children && (
        <Box pl={6} pb={2}>
          {Children.only(props.children)}
        </Box>
      )}
    </Box>
  );
}
